import { useMemo } from 'react';
import checkIsTagOutOfStock from 'functions/checkIsTagOutOfStock';

const useTagIsOutOfStock = marker => useMemo(() => checkIsTagOutOfStock(marker), [marker]);

export default useTagIsOutOfStock;
